import { FC } from 'react';
import { CircleCloseIcon, SubscriptionTimerIcon } from 'assets/icons';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import CustomModal from 'components/custom-modal/CustomModal';
import { TeamRole } from 'containers/app/app.model';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { VoidFn } from 'types/baseTypes';
import { getAmountWithCurrency } from 'utils/amountUtils';

interface EstimateSubscriptionEndedModalProps {
  onClose: VoidFn;
  handlePrimaryAction: VoidFn;
  price: number;
}

const EstimateSubscriptionEndedModal: FC<EstimateSubscriptionEndedModalProps> = ({
  onClose,
  handlePrimaryAction,
  price
}) => {
  const { role } = useAppSelector(selectCurrentTeam);

  const isOwner = role === TeamRole.OWNER;

  const handleChatWithUsClick = () => {
    onClose();
    window.fcWidget.open();
  };

  return (
    <CustomModal open={true} width={isOwner ? 'md:w-[579px]' : 'md:w-[489px]'}>
      <div className="relative px-10 py-9">
        <CircleCloseIcon className="absolute top-[9px] right-[9px] cursor-pointer" onClick={onClose} />
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondaryBtn">
          <SubscriptionTimerIcon />
        </div>
        <div className="mb-3.5 text-center text-xl font-bold text-heading">
          {isOwner ? (
            <>
              <p>Your subscription has ended,</p>
              <p>renew for {getAmountWithCurrency(price / 100)}/month</p>
            </>
          ) : (
            'Estimate subscription ended'
          )}
        </div>
        <div className="mb-6 text-center text-17px text-primaryText">
          {isOwner
            ? 'Please renew your estimate subscription to create new estimates'
            : 'Please reach out to your business owner to enable the Estimates feature.'}
        </div>
        <div className="flex items-center justify-end gap-5">
          <CustomButton
            className="h-12 w-full"
            type={ButtonType.PRIMARY}
            id="renew-subscription-button"
            onClick={handlePrimaryAction}>
            {isOwner ? 'Renew subscription' : 'Okay'}
          </CustomButton>
        </div>
        {isOwner && (
          <div className="mt-4 cursor-pointer text-center text-sbase font-medium text-accentText">
            Need help?{' '}
            <a onClick={handleChatWithUsClick} className="cursor-pointer font-bold text-secondary">
              Chat with us
            </a>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default EstimateSubscriptionEndedModal;
